import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { FranchiseWithDistance } from "../../../utils/types";

export interface LocationState {
  location: { lat: number; lng: number } | null;
  sortedFranchises: FranchiseWithDistance[];
  clickDetected: boolean;
}

const initialState: LocationState = {
  location: null,
  sortedFranchises: [],
  clickDetected: false,
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setLocation(state, action: PayloadAction<{ lat: number; lng: number }>) {
      state.location = action.payload;
    },
    setSortedFranchises(state, action: PayloadAction<FranchiseWithDistance[]>) {
      state.sortedFranchises = action.payload;
    },
    setClickDetected(state, action: PayloadAction<boolean>) {
      state.clickDetected = action.payload;
    },
  },
});

export const { setLocation, setSortedFranchises, setClickDetected } =
  locationSlice.actions;

export default locationSlice.reducer;
